import { filterL, go, isNil, map, rejectL } from "fxjs/es";
export const getOverrideCopyDestinationGridIds = (self) => {
  if (self._copy_source_grid_id == null) {
    throw new Error(`먼저 복사를 시작해주세요.`);
  }
  const copy_destination_selected_grid_layer_el =
    self._getCopyDestinationSelectedGridLayerElThrowable();
  return go(
    self._grids.values(),
    filterL(({ copy_destination_selected_grid_el }) =>
      copy_destination_selected_grid_layer_el.contains(
        copy_destination_selected_grid_el
      )
    ),
    rejectL(({ target_image_el }) => isNil(target_image_el)),
    map(({ id }) => id)
  );
};
